export default __webpack_public_path__ + "static/media/SmPC.159e40de.pdf";